export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const CLEAR_ALERTS = 'CLEAR_ALERTS';

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const POST_AD = 'POST_AD';
export const AD_POSTED_BY_OTHER = 'AD_POSTED_BY_OTHER';
export const LOAD_ADS = 'LOAD_ADS';
export const REMOVE_AD = 'REMOVE_AD';
export const ADD_AD = 'ADD_AD';
export const LOAD_AD_DETAILS = 'LOAD_AD_DETAILS';
export const CLEAR_AD_DETAILS = 'CLEAR_AD_DETAILS';
export const LOAD_AD_IMAGE = 'LOAD_AD_IMAGE';
export const IMAGE_LOADING = 'IMAGE_LOADING';
export const CLEAR_AD_IMAGE = 'CLEAR_AD_IMAGE';
export const LOAD_HIGHEST_BID = 'LOAD_HIGHEST_BID';
export const PLACE_BID = 'PLACE_BID';

export const START_AUCTION = 'START_AUCTION';

export const USER_PURCHASED_LOADED = 'USER_PURCHASED_LOADED';
export const UPDATE_AD_IN_AD_LIST = 'UPDATE_AD_IN_AD_LIST';
export const UPDATE_AD_DETAILS = 'UPDATE_AD_DETAILS';
export const UPDATE_TIMER = 'UPDATE_TIMER';
